import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Logo from '../Logo';
import RightOptions from './RightOptions';
import { Content } from './style';
import { clearToken } from '../../redux/modules/auth/actions';
import { clearSelectedDate } from '../../redux/modules/dates/actions';
import { clearNewWorksTotal } from '../../redux/modules/works/actions';
import { applicationCleanState, setActiveItem } from 'redux/modules/application/actions';

export default () => {
  const dispatch = useDispatch();
  const { fullname, role } = useSelector((state) => state.authReducer);
  const handleLogout = () => {
    dispatch(clearToken());
    dispatch(applicationCleanState());
    dispatch(clearNewWorksTotal());
    dispatch(clearSelectedDate());
    dispatch(setActiveItem('all'));
  };
  const roles = {
    supervisor: true,
  };

  return (
    <Content>
      {roles[role] && <Logo />}
      {!roles[role] && (
        <span
          style={{
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: '24px',
            color: '#A8A8A8',
          }}
        >
          Маънавий маърифий тадбирлар базаси
        </span>
      )}

      <RightOptions handleLogout={handleLogout} user={fullname} />
    </Content>
  );
};
